import {
	EmptyCartButton,
	FloatingBarContainer,
	FloatingButtonGroup,
	FloatingButtonRow,
	SaveLoadButtonGroup
} from "features/MarketingMaterials/pages/Checkout/components/ViewCartFloatingBar/ViewCartFloatingBar.styles.ts";
import CancelIcon from "@mui/icons-material/Cancel";
import { Button, ButtonGroup, Skeleton } from "@mui/material";
import useMarketingMaterialsCart from "features/MarketingMaterials/hooks/useMarketingMaterialsCart.ts";
import SaveIcon from "@mui/icons-material/Save";
import { useNavigate } from "react-router";
import { LoadCartTemplateModal } from "features/MarketingMaterials/pages/Checkout/components/ViewCartModals/LoadCartTemplateModal.tsx";
import { useState } from "react";
import { SaveCartTemplateModal } from "features/MarketingMaterials/pages/Checkout/components/ViewCartModals/SaveCartTemplateModal.tsx";
import { EmptyCartModal } from "features/MarketingMaterials/pages/Checkout/components/ViewCartModals/EmptyCartModal.tsx";
import { useSaveCartTemplateMutation } from "features/MarketingMaterials/api/merchProductsApi.ts";
import { useDispatch } from "react-redux";
import { marketingMaterialsCartActions } from "features/reducers/marketingMaterials/cart.ts";
import { getMarketingMaterialsLandingUrl } from "features/MarketingMaterials/utils/getMarketingMaterialsLandingUrl.ts";

export const ViewCartFloatingBar = () => {
	const { isShoppingCartLoading, isValidatingShoppingCart, validateShoppingCart, emptyCart, loadCart } =
		useMarketingMaterialsCart();
	const navigate = useNavigate();
	const [loadTemplateModalIsOpen, setLoadTemplateModalIsOpen] = useState(false);
	const [saveTemplateModalIsOpen, setSaveTemplateModalIsOpen] = useState(false);
	const [emptyCartModalIsOpen, setEmptyCartModalIsOpen] = useState(false);
	const [saveCartAsTemplate, { isLoading: isSaving }] = useSaveCartTemplateMutation();
	const dispatch = useDispatch();

	const handleCheckout = async () => {
		const isValid = await validateShoppingCart();

		if (isValid) {
			navigate("/marketing-materials/shipping-details");
		}
	};

	const handleEmptyCart = async () => {
		await emptyCart(null);
	};

	const handleOnLoadSubmit = async (templateId: string) => {
		await loadCart(templateId);
		setLoadTemplateModalIsOpen(false);
	};

	const handleOnSaveSubmit = async (cartName: string) => {
		const newCart = await saveCartAsTemplate({ cartName }).unwrap();
		dispatch(marketingMaterialsCartActions.setCartItems(newCart?.items ?? []));
		setSaveTemplateModalIsOpen(false);
	};

	return (
		<>
			<FloatingBarContainer>
				{isShoppingCartLoading ? (
					<Skeleton
						variant="rectangular"
						height="120px"
					/>
				) : (
					<FloatingButtonRow>
						<EmptyCartButton
							variant="outlined"
							onClick={() => setEmptyCartModalIsOpen(true)}
						>
							<CancelIcon fontSize="small" />
							Empty Cart
						</EmptyCartButton>
						<SaveLoadButtonGroup>
							<ButtonGroup>
								<Button
									startIcon={<SaveIcon />}
									onClick={() => setSaveTemplateModalIsOpen(true)}
								>
									Save This Cart
								</Button>
								<Button onClick={() => setLoadTemplateModalIsOpen(true)}>Load A Cart</Button>
							</ButtonGroup>
						</SaveLoadButtonGroup>
						<FloatingButtonGroup>
							<Button
								variant="text"
								onClick={() => navigate(getMarketingMaterialsLandingUrl())}
							>
								Continue Shopping
							</Button>
							<Button
								variant="contained"
								onClick={handleCheckout}
								disabled={isValidatingShoppingCart}
							>
								Checkout
							</Button>
						</FloatingButtonGroup>
					</FloatingButtonRow>
				)}
			</FloatingBarContainer>
			<LoadCartTemplateModal
				isOpen={loadTemplateModalIsOpen}
				onClose={() => setLoadTemplateModalIsOpen(false)}
				onSubmit={handleOnLoadSubmit}
			/>
			<SaveCartTemplateModal
				isOpen={saveTemplateModalIsOpen}
				onClose={() => setSaveTemplateModalIsOpen(false)}
				onSubmit={handleOnSaveSubmit}
				isSaving={isSaving}
			/>
			<EmptyCartModal
				isOpen={emptyCartModalIsOpen}
				onClose={() => setEmptyCartModalIsOpen(false)}
				onSubmit={handleEmptyCart}
			/>
		</>
	);
};
